  @if(userLogado?.codigoPerfil == 1634 && userLogado?.autorizacaoUsoDados != 1){
    <app-modal-autorizacao [userLogado]="userLogado"></app-modal-autorizacao>
  }

  <breadcrumb [paginas]="[{route:'/home',name:'Home'}]"></breadcrumb>

  <app-filtro-padrao
    (filtroEmitter)="listeningFiltroEmitter($event)"
    [template]="4"
    [usePolo]="true"
    [useAno]="true"
    [atividadeDE]="true"
    [textoLupa]="true">
  </app-filtro-padrao>

  <app-modal-notificacoes-alert [chamadosAtrasados]="lstChamadosAtrasados"
                                [planosContingenciaPendentes]="lstPlanosContingenciaPendentes"
                                [planosMelhoriaPendentes]="lstPlanosMelhoriaPendentes"
                                [contagemPlanoContingenciaValidacao]="contagemPlanoContingenciaValidacao"
                                [contagemPmceValidacao]="contagemPmceValidacao"
                                [showModalNotificacao]="showModalNotificacao"
                                [mensagemNotificacao]="mensagemNotificacao"
                                [perfil]="codigoPerfilAtual" />

  <!-- SAUDACAO USUÁRIO -->
  <section class="section-saudacao" aria-labelledby="saudacao-title">
    <div class="container">
      <p>
        <b>Olá,</b> {{this.userLogado?.flPsicologo ? "Psicólogo(a)": this.atribuicoesLogin.NomePerfil }}<br />
        <b>{{this.userLogado?.flPsicologo ? this.userLogado?.nome : this.atribuicoesLogin.Nome}}</b>
      </p>
    </div>
  </section>

  <visibility-manager [funcionalidadeId]="18" *ngIf="filtrosCalendarios()?.codigoEscola">
    <calendario-component
    [filtroCalendario]="filtrosCalendarios()"
      aria-label="Calendário de atividades"/>
  </visibility-manager>

  <section class="section-titulo">
    <div class="container">
      <div class="row">
        <h2 class="titulo-page">Resumo do ciclo anual</h2>
        <div class="card" (click)="exportarPDF()" style="cursor: pointer;">
          <img src="../../../assets/img/icons/icon-download-red.svg" alt="PDF" />
          <h3>PDF</h3>
        </div>
      </div>

      <!-- Filter Display Modules -->
      <div class="row filter-modules-row">
        @if(getDescricaoPolo()) {
          <div class="filter-module">
            <p class="filter-label">Polo</p>
            <p class="filter-value">{{ getDescricaoPolo() }}</p>
          </div>
        }
        @if(getNomeDiretoria()) {
          <div class="filter-module">
            <p class="filter-label">URE</p>
            <p class="filter-value">{{ getNomeDiretoria() }}</p>
          </div>
        }
        @if(getNomeEscola()) {
          <div class="filter-module">
            <p class="filter-label">Escola</p>
            <p class="filter-value">{{ getNomeEscola() }}</p>
          </div>
        }
        @if(getNomeMunicipio()) {
          <div class="filter-module">
            <p class="filter-label">Município</p>
            <p class="filter-value">{{ getNomeMunicipio() }}</p>
          </div>
        }
        @if(getNomeTipoEnsino()) {
          <div class="filter-module">
            <p class="filter-label">Ciclo</p>
            <p class="filter-value">{{ getNomeTipoEnsino() }}</p>
          </div>
        }
        @if(getNomeTurno()) {
          <div class="filter-module">
            <p class="filter-label">Turno</p>
            <p class="filter-value">{{ getNomeTurno() }}</p>
          </div>
        }
        @if(getAnoAtual()) {
          <div class="filter-module">
            <p class="filter-label">Ano</p>
            <p class="filter-value">{{ getAnoAtual() }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <section class="section-conteudo" aria-labelledby="conteudo-title">
    <div class="container">

    <div class="row">

      <div class="col-2">
        <app-chart-pec
          [titulo]="'Ocorrências'"
          [elementos]="elementosOcorrencias">
        </app-chart-pec>
      </div>

      <div class="col-2">
        <app-chart-pec
          [titulo]="'Dias sem ocorrências'"
          [elementos]="elementosDiasSemOcorrencias">
        </app-chart-pec>
      </div>

      <div class="col-2">
        <app-chart-pec
          [titulo]="'PMCE'"
          [elementos]="elementosPMCE">
        </app-chart-pec>
      </div>

      <div class="col-2">
        <app-chart-pec
          [titulo]="'Plano de Contingência'"
          [elementos]="elementosPlanoContingencia">
        </app-chart-pec>
      </div>

      <div class="col-2">
        <app-chart-pec
          [titulo]="'Psicólogos'"
          [elementos]="elementosPsicologos">
        </app-chart-pec>
      </div>

      <div class="col-2">
        <app-chart-pec
          [titulo]="'POC'"
          [elementos]="elementosPOC">
        </app-chart-pec>
      </div>      

    </div>

    </div>
  </section>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>

<app-modal *ngIf="showModal">
  <form [formGroup]="formModal">
    <div>
      <div>
        <h1 class="titulo-page">{{ this.tituloModal }}</h1>
      </div>
      <br />

      <div>
        <div class="container-btns container-btns-centrar grupo-filter">
          <div *ngIf="this.userLogado?.funcionalidades?.includes(6)">
            <button
              type="button"
              (click)="EncaminhamentoPsicologo()"
              class="btn-action">
              <img src="../../../assets/img/icons/btn-hosp.svg" alt="" />
              &nbsp; Psicólogo
            </button>
          </div>
          <br>
          <div *ngIf="this.userLogado?.funcionalidades?.includes(7)">
            <button
              type="button"
              (click)="EncaminhamentoPolicia()"
              class="btn-action">
              <img src="../../../assets/img/icons/btn-police.svg" alt="" />
              &nbsp; Rede Protetiva
            </button>
          </div>
          <br>
          <div *ngIf="this.userLogado?.funcionalidades?.includes(8)">
            <button
              type="button"
              (click)="EncaminhamentoSaude()"
              class="btn-action">
              <img src="../../../assets/img/icons/btn-hosp.svg" alt="" />
              &nbsp; Rede Hospitalar
            </button>
          </div>
          <br>
          <div>
            <button type="button" (click)="FecharModal()" class="btn-action">
              &nbsp; Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</app-modal>

<app-modal *ngIf="showModalCalendarioOcorrencia" class="modal-calendario">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="header-modal-calendario">
      <h1 class="titulo-page">Deseja Inserir Ocorrencia?</h1>
      <a class="btn-fechar-modal" (click)="FecharModalCalendario()" >fechar</a>
    </div>
    <div class="container-btns">
      <input type="button" (click)="InserirOcorrencia()" class="btn_primary" value="Cadastrar Ocorrencia"/>
      <input type="button" (click)="InserirNaoOcorrencia()" class="btn_outline" value="Cadastrar Não Ocorrencia" />
    </div>
  </div>
</app-modal>
